import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ProgressBar } from "react-loader-spinner";

import { fetchWithToken } from "../../../interceptors/fetchInterceptor";

import { MAIN_URL, PORT, API_GET_CLASSIFICATION_BOATS } from "../../../constants/constants";

import styles from "./ClassificationBoats.module.css";

export default function ClassificationBoats() {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const handleCloseButton = () => {
    navigate(-1);
  };

  useEffect(() => {
    async function fetchData() {
      const request = await fetchWithToken(MAIN_URL + PORT + API_GET_CLASSIFICATION_BOATS);
      const response = await request.json();
      setData(response);
      setIsLoading(false);
    }
    fetchData();
  }, []);
  return (
    <div className={styles["content-container"]}>
      {isLoading ? (
        <div className={`d-flex flex-column align-items-center `}>
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass="progress-bar-wrapper"
            borderColor="#D2AF8E"
            barColor="#BC8653"
          />
        </div>
      ) : (
        <>
          <p
            className={styles["back-block"]}
            onClick={() => handleCloseButton()}>
            <span className={styles["back-icon"]}></span>
            <p className={styles["back-text"]}>{"Вернуться к НСИ"}</p>
          </p>
          <h2 className={styles["main-text"]}>Классификатор маломерных судов</h2>
          <p className={styles["secondary-caption"]}>Типы маломерных судов</p>
          <div className={styles["block-container"]}>
            {data.boatTypes.map((item) => {
              return (
                <div className={styles["text-block"]}>
                  <p className={styles["option-label"]}>{item.btname}</p>
                  <p className={styles["option-value"]}>{item.btnote || "—"}</p>
                </div>
              );
            })}
          </div>
          <p className={styles["secondary-caption"]}>Виды маломерных судов</p>
          <div className={styles["block-container"]}>
            {data.boatVids.map((item) => {
              return (
                <div className={styles["text-block"]}>
                  <p className={styles["option-label"]}>{item.name}</p>
                  <p className={styles["option-value"]}>{"—"}</p>
                </div>
              );
            })}
          </div>
          <p className={styles["secondary-caption"]}>Категория сложности района плавания</p>
          <div className={styles["block-container"]}>
            {data.saCategories.map((item) => {
              return (
                <div className={styles["text-block"]}>
                  <p className={styles["option-label"]}>
                    <span className={styles["label-text"]}>{item.sacName}</span>
                  </p>
                  <p className={styles["option-value"]}>{item.sacNote || "—"}</p>
                </div>
              );
            })}
          </div>
          <div
            className={styles["close-btn"]}
            onClick={() => handleCloseButton()}>
            Закрыть
          </div>
        </>
      )}
    </div>
  );
}
